var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11405_34371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 80.5C63.0914 80.5 81 62.5914 81 40.5C81 18.4086 63.0914 0.5 41 0.5C18.9086 0.5 1 18.4086 1 40.5C1 62.5914 18.9086 80.5 41 80.5Z",
    fill: "#FAEAE7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8322 62.0532L26.4838 64.7917C26.1391 64.5395 25.8654 64.2007 25.6897 63.8086C25.514 63.4166 25.4423 62.985 25.4818 62.5564L20.8302 59.8262C20.7922 60.2535 20.8645 60.6835 21.0402 61.0739C21.2159 61.4643 21.4888 61.8018 21.8322 62.0532Z",
    fill: "#F4D3CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3162 19.4586L52.6646 16.7284C52.2734 16.5452 51.8412 16.4701 51.4119 16.5107C50.9827 16.5513 50.5718 16.7061 50.2207 16.9594L54.8723 19.6978C55.2226 19.4431 55.6332 19.2869 56.0624 19.2449C56.4917 19.2029 56.9242 19.2766 57.3162 19.4586Z",
    fill: "#F4D3CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3919 40.9367L20.7402 38.1982L20.8298 59.817L25.4815 62.5554L25.3919 40.9367Z",
    fill: "#EEBCB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8808 19.6974L50.2291 16.959L24.1523 32.2018L28.804 34.9402L54.8808 19.6974Z",
    fill: "#EEBCB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8133 34.9816L24.1617 32.2432C23.1647 32.8986 22.3349 33.7835 21.7402 34.8257C21.1456 35.8679 20.803 37.0377 20.7402 38.2396L25.3918 40.9781C25.4546 39.7761 25.7973 38.6063 26.3919 37.5641C26.9866 36.5219 27.8163 35.637 28.8133 34.9816Z",
    fill: "#F4D3CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.814 34.9816C27.817 35.6371 26.9873 36.522 26.3927 37.5641C25.798 38.6063 25.4553 39.7762 25.3926 40.9781L25.4822 62.5969C25.4822 64.8074 27.03 65.69 28.9281 64.5847L54.9968 49.3419C55.9927 48.6873 56.8218 47.8037 57.4164 46.763C58.011 45.7224 58.3543 44.5542 58.4183 43.3537L58.3206 21.7267C58.3206 19.5326 56.7727 18.6335 54.8827 19.7388L28.814 34.9816Z",
    fill: "#E38D7B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4075 45.822L27.7617 38.0719L41.6843 43.381L57.1136 20.0088L42.4075 45.822Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5661 44.7278L27.2656 63.8797L39.0644 45.8655L37.5661 44.7278Z",
    fill: "#DDDDDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8365 40.082L57.0434 45.8655L46.1811 41.5042L46.8365 40.082Z",
    fill: "#DDDDDD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11405_34371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(1 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.a2d7d1cafadc52fccf0f0ffa6c8a474d.svg";
export { ForwardRef as ReactComponent };